import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const CREATE_QUESTION = 'CREATE_QUESTION';
export const CREATE_QUESTION_SUCCESS = 'CREATE_QUESTION_SUCCESS';
export const CREATE_QUESTION_FAILURE = 'CREATE_QUESTION_FAILURE';

// Action Creators
export const getCreateQuestionRequest = () => ({
  type: CREATE_QUESTION,
});

export const getCreateQuestionSuccess = (users) => ({
  type: CREATE_QUESTION_SUCCESS,
  payload: users,
});

export const getCreateQuestionFailure = (error) => ({
  type: CREATE_QUESTION_FAILURE,
  payload: error,
});

// Thunk Function
export const postQuestionRequest = (body, external) => {
  return async (dispatch) => {
    dispatch(getCreateQuestionRequest());
    try {
      const response = await postMethodWithToken(url.createQuestion, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getCreateQuestionSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getCreateQuestionFailure('error?.message'));
      }
    } catch (error) {
      dispatch(getCreateQuestionFailure(error?.message));
      if (external?.error === true) {
        external?.handleErrorFunction(error);
      }
    }
  };
};
